import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVuesax = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20.8953 12.5066H17.2903V4.10663C17.2903 2.14663 16.2286 1.74996 14.9336 3.21996L14.0003 4.28163L6.10192 13.265C5.01692 14.49 5.47192 15.4933 7.10526 15.4933H10.7103V23.8933C10.7103 25.8533 11.7719 26.25 13.0669 24.78L14.0003 23.7183L21.8986 14.735C22.9836 13.51 22.5286 12.5066 20.8953 12.5066Z",
		fill: "#407BFF"
	})
});
export default SvgVuesax;
